<template>
  <div>
    <v-card class="mx-auto" v-if="!frmcadastro">
      <v-toolbar color="#2A3F54" class="tbTitle" dark>
        <v-toolbar-title>Permissões</v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-btn color="primary" dark class="mb-2" @click="openform('novo')" :disabled="!permissoes.perfil_incluir">Nova Permissão</v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        v-model="selected"
        locale="pt-BR"
      >
        <template v-slot:item="props">
          <tr @dblclick="openform('editar',props.item.id)">
            <td class="text-xs-right">{{ props.item.formulario }}</td>
            <td class="text-xs-right">{{ props.item.consultar_descr }}</td>
            <td class="text-xs-right">{{ props.item.incluir_descr }}</td>
            <td class="text-xs-right">{{ props.item.alterar_descr }}</td>
            <td class="text-xs-right">{{ props.item.excluir_descr }}</td>
          </tr>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >Sua Pesquisa por "{{ search }}" não encontrou registros.</v-alert>
      </v-data-table>
    </v-card>
    <v-card class="mx-auto" v-if="frmcadastro">
      <v-toolbar color="#2A3F54" class="tbTitle" dark>
        <v-toolbar-title>{{titulo}}</v-toolbar-title>
      </v-toolbar>

      <v-form @submit.prevent="salvar()">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="frmcadastro=false; getData();">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-autocomplete
                label="Permissão"
                v-model="permissao.formulario_id"
                :items="formularios"
                item-text="nome"
                item-value="id"
              ></v-autocomplete>
            </v-col>
            <v-col cols="2">
              <v-switch v-model="permissao.consultar" label="Consultar"></v-switch>
            </v-col>
            <v-col cols="2">
              <v-switch v-model="permissao.incluir" label="Incluir"></v-switch>
            </v-col>
            <v-col cols="2">
              <v-switch v-model="permissao.alterar" label="Alterar"></v-switch>
            </v-col>
            <v-col cols="2">
              <v-switch v-model="permissao.excluir" label="Excluir"></v-switch>
            </v-col>
          </v-row>
          <v-alert
            dense
            outlined
            type="error"
            v-for="(erro, index) of erros"
            :key="index"
          >{{erro[0]}}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn depressed color="error" @click="confirmaExcluir()" v-if="excluir" :disabled="!permissoes.perfil_excluir">EXCLUIR</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" type="submit" :disabled="!permissoes.perfil_alterar">SALVAR</v-btn>
        </v-card-actions>
        <template>
          <v-row justify="center">
            <v-dialog v-model="exclusao" persistent max-width="400">
              <v-card>
                <v-card-title class="headline">Atenção</v-card-title>
                <v-card-text>Deseja realmente excluir esta permissão?</v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="red darken-1" text @click="exclusao = false">NÃO</v-btn>
                  <v-btn color="blue darken-1" text @click="deletar()">SIM</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-form>
    </v-card>
  </div>
</template>
<script>
export default {
  components: {},
  props: ["perfil_id"],
  data() {
    return {
      selected: [],
      search: "",
      headers: [
        { text: "Permissão", value: "formulario", align: "left" },
        { text: "Consultar", value: "consultar_descr" },
        { text: "Incluir", value: "incluir_descr" },
        { text: "Alterar", value: "alterar_descr" },
        { text: "Excluir", value: "excluir_descr" }
      ],
      items: [],
      frmcadastro: false,
      excluir: false,
      exclusao: false,
      readonly: true,
      titulo: String,
      erros: [],
      formularios: [],
      permissao: {
        id: 0,
        perfil_id: 0,
        formulario_id: 0,
        consultar: false,
        incluir: false,
        alterar: false,
        excluir: false
      },
      permissoes: {
        perfil: false,
        perfil_incluir: false,
        perfil_alterar: false,
        perfil_excluir: false
      }
    };
  },
  created: function() {
    this.getData();

    let permAux = this.$store.getters.getPermissoes;

    if (permAux.ativo) {
      this.permissoes = permAux;
      if (!this.permissoes.perfil) this.$router.push("/#");
    }
    else
    this.$router.push("/#");

  },
  methods: {
    getData: function() {
      this.$http
        .get(this.$urlAPI + "/permissao/" + this.perfil_id, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.items = response.data));

      this.$http
        .get(this.$urlAPI + "/form", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.formularios = response.data));
    },
    openform: function(opcao, id) {
      this.frmcadastro = true;
      this.erros = [];
      if (opcao == "novo") {
        this.excluir = false;
        this.titulo = "Nova Permissão";
        this.permissao = {
          id: 0,
          formulario_id: 0,
          perfil_id: this.perfil_id,
          consultar: false,
          incluir: false,
          alterar: false,
          excluir: false
        };
      } else if (opcao == "editar") {
        this.excluir = true;
        this.titulo = "Editar Permissão";

        this.$http
          .get(this.$urlAPI + "/permissao/show/" + id, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            this.permissao = response.data;
            this.permissao.consultar = this.permissao.consultar == "1";
            this.permissao.incluir = this.permissao.incluir == "1";
            this.permissao.alterar = this.permissao.alterar == "1";
            this.permissao.excluir = this.permissao.excluir == "1";
          });
      }
    },
    salvar: function() {
      this.permissao.consultar = this.permissao.consultar == true ? "1" : "0";
      this.permissao.incluir = this.permissao.incluir == true ? "1" : "0";
      this.permissao.alterar = this.permissao.alterar == true ? "1" : "0";
      this.permissao.excluir = this.permissao.excluir == true ? "1" : "0";
      if (this.excluir) {
        this.$http
          .post(
            this.$urlAPI + "/permissao/" + this.permissao.id,
            this.permissao,
            {
              headers: {
                authorization: "Bearer " + this.$store.getters.getToken
              }
            }
          )
          .then(response => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      } else {
        this.$http
          .post(this.$urlAPI + "/permissao", this.permissao, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      }
    },
    confirmaExcluir: function() {
      this.exclusao = true;
    },
    deletar: function() {
      this.$http
        .delete(this.$urlAPI + "/permissao/" + this.permissao.id, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          if (response.data.status) {
            this.frmcadastro = false;
            this.exclusao = false;
            this.getData();
          } else {
            this.erros = null;
            this.erros = response.data.erros;
          }
        })
        .catch(e => {
          this.erros = e.response.data.erros;
        });
    }
  }
};
</script>
